export default "__VITE_ASSET__64b84efa__"